import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private readonly _darkMode: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
    this._darkMode.next(document.documentElement.classList.contains('dark-theme'));
  }

  public toggleDarkMode(): void {
    document.documentElement.classList.toggle('dark-theme');
    this._darkMode.next(!this._darkMode.value);
  }

  public isDarkMode$(): Observable<boolean> {
    return this._darkMode.asObservable();
  }
}
